import { FC } from 'react';

import IconComponent from '../IconComponent';

import { ICONS } from '../../utils/enum/Icons';

interface Props {
    value: string;
    onChange?: (newValue: string) => void;
    label?: string;
    placeholder?: string;
    type?: 'text' | 'date' | 'number';
    max?: number;
    customDivStyle?: React.CSSProperties;
    customInputStyle?: React.CSSProperties;
}

const InputComponent: FC<Props> = ({
    value,
    onChange,
    label = '',
    placeholder = '',
    type = 'text',
    max,
    customDivStyle = undefined,
    customInputStyle = undefined,
}) => {
    return (
        <div style={customDivStyle} className="br-inputComponent">
            {label ? <label>{label}</label> : null}
            {(onChange !== undefined && (
                <input
                    type={type}
                    value={value}
                    placeholder={placeholder}
                    onChange={(element) => {
                        onChange(element.target.value);
                    }}
                    max={max ? max : undefined}
                    style={customInputStyle}
                />
            )) || <span>{value}</span>}
            {type == 'date' ? <IconComponent icon={ICONS.calendar} /> : null}
        </div>
    );
};

export default InputComponent;
